// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__m1IAh","meals-appear":"AvailableMeals_meals-appear__uSKtj"};